/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PoliJobsCandidateDTO,
	PoliJobsCandidateDTOFromJSON,
	PoliJobsCandidateDTOFromJSONTyped,
	PoliJobsCandidateDTOToJSON,
} from "./PoliJobsCandidateDTO";

/**
 *
 * @export
 * @interface PoliJobsCandidateDTOPagedResponse
 */
export interface PoliJobsCandidateDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsCandidateDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsCandidateDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsCandidateDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<PoliJobsCandidateDTO>}
	 * @memberof PoliJobsCandidateDTOPagedResponse
	 */
	data?: Array<PoliJobsCandidateDTO> | null;
}

export function PoliJobsCandidateDTOPagedResponseFromJSON(
	json: any
): PoliJobsCandidateDTOPagedResponse {
	return PoliJobsCandidateDTOPagedResponseFromJSONTyped(json, false);
}

export function PoliJobsCandidateDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsCandidateDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(PoliJobsCandidateDTOFromJSON),
	};
}

export function PoliJobsCandidateDTOPagedResponseToJSON(
	value?: PoliJobsCandidateDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(PoliJobsCandidateDTOToJSON),
	};
}
